import * as ActionTypes from '../Types/ActionTypes';

const initialState = {
  isLoading: false,
  errMess: null,
  stagereview: []
};

export const StageReviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.STAGEREVIEW_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
        errMess: null,
        stagereview: []
      };
    
    case ActionTypes.STAGEREVIEW_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        stagereview: action.payload
      };
    
    case ActionTypes.STAGEREVIEW_ERROR:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        stagereview: []
      };
    
    default:
      return state;
  }
};